import { clsx, type ClassValue } from "cn";
import { extendTailwindMerge } from "cn/config";

const mergePortalClasses = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        "page-title",
        "metric",
        "dialog-title",
        "section-title",
        "subsection",
        "body",
        "data",
        "meta",
        "label",
        "chip",
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]): string {
  return mergePortalClasses(clsx(inputs))
}

/**
 * Format a date string to a human-readable format
 */
export function formatDate(dateString: string): string {
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}

/**
 * Format a date string to include time
 */
export function formatDateTime(dateString: string): string {
  const date = new Date(dateString)
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })
}

/**
 * Format a number as currency
 */
export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount / 100)
}
